export default "__VITE_ASSET__29422c4c__"